var Participant = /** @class */ (function () {
    function Participant(_userId, _roomId, _userData, _isAdmin) {
        if (_userData === void 0) { _userData = {}; }
        if (_isAdmin === void 0) { _isAdmin = false; }
        this.isAdmin = false;
        this.isAudioBlockedByAdmin = false;
        this.isVideoBlockedByAdmin = false;
        this.isMessageBlockedByAdmin = false;
        this.isWhiteboardBlockedByAdmin = true;
        this.isScreenshareBlockedByAdmin = false;
        this.isVideoEnable = false;
        this.isAudioEnable = false;
        this.isStartMeetingCalled = false;
        this.isRecordingUser = false;
        this.userId = _userId;
        this.roomId = _roomId;
        this.userData = _userData;
        this.isAdmin = _isAdmin;
    }
    return Participant;
}());
export { Participant };
